import { render } from "./FpuiCanvasIcon.vue?vue&type=template&id=6f38b1c4&lang=pug"
import script from "./FpuiCanvasIcon.vue?vue&type=script&lang=js"
export * from "./FpuiCanvasIcon.vue?vue&type=script&lang=js"

import "./FpuiCanvasIcon.vue?vue&type=style&index=0&id=6f38b1c4&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__